import { auth, db } from '../firebase';

export async function testStripeOnboard() {
    const user = auth.currentUser;
    if (!user) {
        alert("Non sei loggato");
        return;
    }

    const idToken = await user.getIdToken(true);
    const res = await fetch("https://us-central1-mima-7b65c.cloudfunctions.net/creaConnectedAccount", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
        },
        body: JSON.stringify({ mode: "check" })
    });
    const data = await res.json();
   
    if (data.url) window.open(data.url, "_blank");
}
